import Accordion from "@/common/components/Accordion";
import { useEffect, useState } from "react";
import { MaintenanceForwardingsDirectiveFormStepState } from "../types/maintenanceforwardingsDirectiveFormStep.type";

interface CreateForwardingDirectiveEntryFormStepAccordionProps {
  state: MaintenanceForwardingsDirectiveFormStepState;
  title: string;
  body: JSX.Element;
}

const CreateForwardingDirectiveEntryFormStepAccordion = ({
  state,
  title,
  body,
}: CreateForwardingDirectiveEntryFormStepAccordionProps) => {
  const [open, setOpen] = useState(state === 'current');

  useEffect(() => {
    setOpen(state === 'current');
  }, [state]);

  return (
    <Accordion
      open={open}
      defaultOpen={open}
      onToggle={setOpen}
      triggerDisabled={state === 'pending'}
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="px-4 pb-4"
      head={title}
      body={body}
    />
  );
}

export default CreateForwardingDirectiveEntryFormStepAccordion;
